import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import CircularProgress from "@mui/material/CircularProgress";
import {
  FaWhatsapp,
  FaArrowUp,
  FaFacebookF,
  FaInstagram,
  FaLinkedinIn,
  FaYoutube
} from "react-icons/fa";
import { collection, getDocs, query, where } from "firebase/firestore";
import { db } from "../firebase-config";

function Footer() {
  const [showTop, setShowTop] = useState(false);
  const [contactData, setContactData] = useState(null);;
  const [loading, setLoading] = useState(true);
  /* ================= FETCH CONTACT DATA ================= */
  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoading(true);

        const q = query(
          collection(db, "ownerPageDatas"),
          where("selectedmenutype", "==", "Contact")
        );
        const snapshot = await getDocs(q);
        const data = snapshot.docs.map((doc) => ({
          id: doc.id,
          ...doc.data(),
        }));

        setContactData(data[0]);
      } catch (error) {
        console.error(error);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  useEffect(() => {
    const handleScroll = () => {
      setShowTop(window.scrollY > 300);
    };
    window.addEventListener("scroll", handleScroll);
    return () =>
      window.removeEventListener("scroll", handleScroll);
  }, []);

  const scrollTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth"
    });
  };
  // 👇 Loader here
  if (loading) {
    return (
      <div
        style={{
          height: "100vh",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <CircularProgress size={60} sx={{ color: "#45B2F7" }} />
      </div>
    );
  }
  return (
    <>
      <footer className="footer">
        <div className="footerContainer">

          {/* LEFT */}
          <div className="footerBox">
            <h2 className="logo">MAS mobility Service</h2>
            <p>+966-{contactData?.mobilenumber || "9696000329"}</p>
            <p>{contactData?.email || "Masmobilityservice@gmail.com"}</p>
            <div className="socialIcons">
              <a
                href={contactData?.facebook || ""}
                target="_blank"
                rel="noopener noreferrer"
              >
                <FaFacebookF />
              </a>
              <a
                href={contactData?.linkedin || ""}
                target="_blank"
                rel="noopener noreferrer"
              >
                <FaLinkedinIn />
              </a>
              <a
                href={contactData?.instagram || ""}
                target="_blank"
                rel="noopener noreferrer"
              >
                <FaInstagram />
              </a>
              <a
                href={contactData?.youtube || ""}
                target="_blank"
                rel="noopener noreferrer"
              >
                <FaYoutube />
              </a>
            </div>
          </div>

          {/* NAVIGATION (Same as Navbar) */}
          <div className="footerBox">
            <h4>QUICK LINKS</h4>
            <p><Link to="/home"> Home</Link></p>
            <p><Link to="/contact"> Contact us</Link></p>
            <p><Link to="/business"> Business</Link></p>
            <p><Link to="/about"> About us</Link></p>
          </div>
          {/* SERVICES */}
          <div className="footerBox">
            <h4> OUR SERVICES</h4>
            <p> <Link to="/Airporttransfers">Airport Transfers</Link> </p>
            <p><Link to="/chauffer">Chauffeur Service</Link></p>
            <p><Link to="/citytocity">City to City Transfer</Link></p>
            <p><Link to="/eventtransportation">Event Transportation</Link></p>
            <p><Link to="/hirebythehour">Hire by the hour</Link></p>
          </div>
          {/* COMPANY */}
          <div className="footerBox">
            <h4>USEFUL LINKS</h4>
            <p><Link to="/privacy">Privacy</Link> </p>
            <p><Link to="/terms&conditions">TermsandCondition</Link></p>
            <p><Link to="/cookiepolicy">Cookies Policy</Link></p>
            <p><Link to="/deliverypolicy">Delivery Information</Link></p>
          </div>
          {/* NEWSLETTER */}
          <div className="footerBox">
            <h4>CONNECT WITH US</h4>
            <p>
              Book and manage chauffeur airport services,
              Payment is encrypted securely with SSL protocol.
            </p>
          </div>
        </div>
        <div className="copyright">
          © 2026 MAS mobility Service. All Rights Reserved.
        </div>
      </footer>
      {/* WhatsApp */}
      <a
        href={`https://wa.me/966${contactData?.mobilenumber || "530741843"}`}
        target="_blank"
        rel="noreferrer"
        className="whatsappBtn"
        title="Chat on WhatsApp"
      >
        <FaWhatsapp />
      </a>
      {/* Scroll Top */}
      {showTop && (
        <div className="scrollTop" onClick={scrollTop}>
          <FaArrowUp />
        </div>
      )}
      <br />
    </>
  );
}

export default Footer;